export default __webpack_public_path__ + "static/media/dtsd5168-7.0336d641.png";